<div
  class="kds-Card flex flex-row items-center justify-between shadow-4 card-shadow hover:shadow-8 rounded-medium history-card"
  (click)="navigate()"
>
  <div class="flex flex-row items-center">
    <img
      *ngIf="cardType === 'TCC'"
      src="../../../../assets/icons/policies.svg"
      alt="kds accent icon add to list"
    />
    <kds-accent-icon-add-to-list
      *ngIf="cardType === 'auditHistory'"
      size="s"
    ></kds-accent-icon-add-to-list>
    <div class="ml-16 lh-20">
      <p class="heading-m nunito-regular-font">{{ cardHeading }}</p>
      <p class="body-s text-neutral-800 roboto-medium-font mt-4">
        {{ cardDescription }}
      </p>
    </div>
  </div>
  <kds-icon-caret-right size="xs" class="navigate-style"></kds-icon-caret-right>
</div>
